<template>
  <div>
    <el-container style="height: 100vh">
      <el-aside width="200px">
        <Sidenav/>
      </el-aside>
      <el-container>
        <el-header style="padding: 0;">
          <Header/>
        </el-header>
        <el-main>
          <div class="home_main" style="background: white;padding: 20px">
            <router-view/>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Header from "@/components/Header";
import Sidenav from "@/components/Sidenav";
export default { 
  data(){
    return{
      currentTab:'',
      tabList:[
        {label:'主页',name:'/home/workbench'}
      ],
      isCollapse:true
    }
  },
  components: {
    Header,
    Sidenav
  },
  created() {
  },
  methods:{
  }
};
</script>
<style lang="scss">
.el-tabs--border-card > .el-tabs__header{

}
.home_mainTop .el-tabs__header {
  position: sticky;
  z-index: 9;
  top: 0;
}
</style>
<style lang="scss" scoped>
</style>
